import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deleteCityForm} from "../store/actions/cityForm";
import {Alert, Button, Spinner} from "reactstrap";


type CityDeleteType = {
    deleteCityForm: (id: number) => void
    cancelHandler?: () => void
    id: number
    changeLoading: boolean
    changeError: string
}

class CityDeleteContainer extends Component<CityDeleteType> {

    render() {
        const {id, changeLoading, changeError, cancelHandler, deleteCityForm} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler &&
                    <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={() => deleteCityForm(id)} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner

                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.cityForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deleteCityForm
};


export default connect(mapStateToProps, mapDispatchToProps)(CityDeleteContainer);
